import { Box, PopoverTrigger } from "@chakra-ui/react";
import {
  ProgressBar,
  ProgressBarOurWorkSpendPercent,
} from "@src/components/ui-kit";
import { TooltipComplexOurWork } from "@src/components/widgets/TooltipComplexOurWork";
import { can } from "@src/utils/components/permissions";
import { currency, inputPercent, percent } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

interface OurWorkProps {
  progressPercent: number;
  totalBudget: number;
  spentBudget: number;
  spentBudgetPercent: number;
  spentTime: number;
  remainingBudget: number;
  remainingTime: number;
}

const OurWork = (props: OurWorkProps) => {
  return (
    <TooltipComplexOurWork
      timeTracking={{
        percent: props.spentBudgetPercent,
        value: props.spentBudget,
        time: props.spentTime,
      }}
      progress={{
        percent: props.progressPercent,
        value: props.remainingBudget,
        time: props.remainingTime,
      }}
    >
      <PopoverTrigger>
        <Box>
          <div className="text-lg">
            {currency.formatByWorkspace(props.spentBudget)} /{" "}
            {currency.formatByWorkspace(props.totalBudget)}{" "}
            <span className="text-gray-600">
              ({percent.format(props.spentBudgetPercent)})
            </span>
          </div>

          <ProgressBarOurWorkSpendPercent
            progress={inputPercent.format(props.spentBudgetPercent)}
          />

          {can(["wip_read_all", "wip_read_team", "wip_read_own"]) && (
            <div className="my-1 pt-2">
              <ProgressBar
                color="purple"
                show100
                progress={inputPercent.format(props.progressPercent)}
              />
            </div>
          )}
        </Box>
      </PopoverTrigger>
    </TooltipComplexOurWork>
  );
};

export default observer(OurWork);
